import { defineStore } from "pinia"

import http from "~/services/http"

interface SearchResultItem {
  type: string
  id: number
  name: string
  page?: number
  product: Record<string, any>
}

interface SearchState {
  query: string
  results: SearchResultItem[]
  loading: boolean
}

const useSearchStore = defineStore("searchStore", {
  state: (): SearchState => ({
    query: "",
    results: [],
    loading: false,
  }),

  actions: {
    search(query: string) {
      this.query = query
      this.loading = true

      http.get({
        url: "v2/products/search",
        params: { query },
        successCallback: (context) => {
          this.results = context.response._data.results
          this.loading = false
        },
        errorCallback: () => {
          this.results = []
          this.loading = false
        },
      })
    },

    clear() {
      this.query = ""
      this.results = []
      this.loading = false
    },
  },
})

export { useSearchStore }
